import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import { getRefresh } from "../../actions/index";
import { useSelector, useDispatch } from "react-redux";
import { BASE_PATH } from "../../constants/Global";
import Header from "../../component/include/Header";
import { svg } from "../../constants/Images";
import { useMediaQuery } from 'react-responsive'

const Navigationtitle = (match) => {
  const dispatch = useDispatch();
  const refreshpage = useSelector((state) => state.setRefresh);
  const loginuser = useSelector((state) => state.setUserlog);
  const history = useHistory({ forceRefresh: true });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  // let classalign = match.data.link == undefined ? "text-left " : "text-left ";
  const aname = localStorage.getItem("auction_name");
  const linkar =
    match.data.link && match.data.link != "" ? match.data.link.split(",") : [];

  if (loginuser == "" && match.data.loginStatus != false) {
    history.push(BASE_PATH + "/");
  }

  const refreshdata = (value) => {
    dispatch(getRefresh(value));
  };

  const location = useLocation();
  const url = location.pathname.split("/")[1];
  //  console.log(url, "dsfsdfsdf");
  var mystyle={}
  if (!loginuser) {
    if (isTabletOrMobile || isPortrait) {
      mystyle = {
        marginLeft: "10%"
      }
  
    }
    else {
      mystyle = {
        marginLeft: "-25%"
      }
  
    }
  
  }
  return (
    <>
      {/* <Header data={match}/>  */}
      <div className={"breadcrumb-area heading-bg"}>
        <div style={mystyle} className="heading-title">
          <div className="row ">
            <div
              className={
                match.data.link == undefined
                  ? "col-md-10 col-xs-12 margin-top-60px padding-left-0px"
                  : "col-md-10 col-xs-12 margin-top-60px padding-left-0px"
              }
            >
              <ul className="breadcrumb">
                <li>
                  <Link to="/">Home</Link>
                </li>
                {location.pathname === "/Dashboard" ? (
                  <li className="active">
                    <Link to="/Dashboard">{svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                  </li>
                ) : null}

                {location.pathname === "/new-auction" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; New Auction</Link>
                    </li>
                  </>
                ) : null}
                {url === "edit-auction" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/edit-auction/:id"> {svg.vectorArrow}&nbsp;&nbsp; Edit Auction</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/join-auction-code" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/join-auction-code"> {svg.vectorArrow}&nbsp;&nbsp; Join Auction</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/join-auction" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/join-auction"> {svg.vectorArrow}&nbsp;&nbsp; Join Auction</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/my-auction" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                  </>
                ) : null}
                {(url === "auction-detail" || url === "auction-customization" || url === "auction-customization2" || url === "overlay-customization" || url === "public-view-customization") ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    {url === "auction-customization" && (
                      <li className="active">
                        <span> {svg.vectorArrow}&nbsp;&nbsp; Auction customization</span>
                      </li>
                    )}
                    {url === "auction-customization2" && (
                      <>
                        <li className="active">
                          <Link to="/auction-customization"> {svg.vectorArrow}&nbsp;&nbsp; Auction customization</Link>
                        </li>
                        <li className="active">
                          <span> {svg.vectorArrow}&nbsp;&nbsp; Auction customization2</span>
                        </li>
                      </>
                    )}
                    {url === "overlay-customization" && (
                      <>
                        <li className="active">
                          <Link to="/auction-customization"> {svg.vectorArrow}&nbsp;&nbsp; Auction customization</Link>
                        </li>
                        <li className="active">
                          <span> {svg.vectorArrow}&nbsp;&nbsp; Overlay customization</span>
                        </li>
                      </>
                    )}
                    {url === "public-view-customization" && (
                      <>
                        <li className="active">
                          <Link to="/auction-customization"> {svg.vectorArrow}&nbsp;&nbsp; Auction customization</Link>
                        </li>
                        <li className="active">
                          <span> {svg.vectorArrow}&nbsp;&nbsp; Public view customization</span>
                        </li>
                      </>
                    )}
                  </>
                ) : null}
                {url === "auction-team" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-team"> {svg.vectorArrow}&nbsp;&nbsp; Team</Link>
                    </li>
                  </>
                ) : null}
                {url === "join-auction-customization" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/join-auction-customization"> {svg.vectorArrow}&nbsp;&nbsp; join-auction-customization</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/my-profile" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-profile"> {svg.vectorArrow}&nbsp;&nbsp; My Profile</Link>
                    </li>
                  </>
                ) : null}
                {url === "edit-profile" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-profile"> {svg.vectorArrow}&nbsp;&nbsp; My Profile</Link>
                    </li>
                    <li className="active">
                      <Link to="/edit-profile/:id"> {svg.vectorArrow}&nbsp;&nbsp; Edit Profile</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/add-auction-category" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-category">
                        {" "}
                        {svg.vectorArrow}&nbsp;&nbsp; Auction Category
                      </Link>
                    </li>
                    <li className="active">
                      <Link to="/add-auction-category">
                        {" "}
                        {svg.vectorArrow}&nbsp;&nbsp; Create Category
                      </Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/auction-category" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-category">
                        {" "}
                        {svg.vectorArrow}&nbsp;&nbsp; Auction Category
                      </Link>
                    </li>
                  </>
                ) : null}
                {url === "today-auction" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/today-auction"> {svg.vectorArrow}&nbsp;&nbsp; Today Auction</Link>
                    </li>
                  </>
                ) : null}
                {url === "edit-auction-category" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-category">
                        {" "}
                        {svg.vectorArrow}&nbsp;&nbsp; Auction Category
                      </Link>
                    </li>
                    <li className="active">
                      <Link to="/add-auction-category">
                        {" "}
                        {svg.vectorArrow}&nbsp;&nbsp; Edit Category
                      </Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/add-auction-player" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-players"> {svg.vectorArrow}&nbsp;&nbsp; Players</Link>
                    </li>
                    <li className="active">
                      <Link to="/add-auction-player"> {svg.vectorArrow}&nbsp;&nbsp; Add Player</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/auction-players" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-players"> {svg.vectorArrow}&nbsp;&nbsp; Players</Link>
                    </li>
                  </>
                ) : null}
                {url === "edit-auction-player" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-players"> {svg.vectorArrow}&nbsp;&nbsp; Players</Link>
                    </li>
                    <li className="active">
                      <Link to="/edit-auction-player"> {svg.vectorArrow}&nbsp;&nbsp; Edit Players</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/change-password" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-profile"> {svg.vectorArrow}&nbsp;&nbsp; My Profile</Link>
                    </li>
                    <li className="active">
                      <Link to="/change-password"> {svg.vectorArrow}&nbsp;&nbsp; Change Password</Link>
                    </li>
                  </>
                ) : null}
                {location.pathname === "/add-auction-team" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-team"> {svg.vectorArrow}&nbsp;&nbsp; Team</Link>
                    </li>
                    <li className="active">
                      <Link to="/change-password"> {svg.vectorArrow}&nbsp;&nbsp; Create Team</Link>
                    </li>
                  </>
                ) : null}
                {url === "edit-auction-team" ? (
                  <>
                    <li className="active">
                      <Link to="/Dashboard"> {svg.vectorArrow}&nbsp;&nbsp; Dashboard</Link>
                    </li>
                    <li className="active">
                      <Link to="/my-auction"> {svg.vectorArrow}&nbsp;&nbsp; My Auction</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-detail"> {svg.vectorArrow}&nbsp;&nbsp; Auction Detail</Link>
                    </li>
                    <li className="active">
                      <Link to="/auction-team"> {svg.vectorArrow}&nbsp;&nbsp; Team</Link>
                    </li>
                    <li className="active">
                      <Link to="/change-password"> {svg.vectorArrow}&nbsp;&nbsp; Edit Team</Link>
                    </li>
                  </>
                ) : null}
                {url === "upcoming-auction" ?
                  <li className="active">
                    <Link to="/upcoming-auction"> {svg.vectorArrow}&nbsp;&nbsp; Upcoming Auction</Link>
                  </li> : null
                }
              </ul>
            </div>

            <div className="col-md-2 col-xs-3 addbtn">
              {linkar.includes("add") ? (
                <Link to={match.data.link_data}>
                  <ul
                    className="breadcrumb heading-btn refresh"
                    data-tip=""
                    data-for="right-menu"
                  >

                    <li className="active">

                      <FaIcons.FaPlus></FaIcons.FaPlus> Add{" "}

                    </li>


                    <ReactTooltip
                      place={"bottom"}
                      backgroundColor="rgba(0,0,0,0.6)"
                      id="right-menu"
                    >
                      Add
                    </ReactTooltip>
                  </ul>
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {(match.data.title == "Players" || match.data.title == "Team") ? (
            <div className="titleaucname">
              <h1>{localStorage.getItem('auction_name')}</h1>
            </div>
          ) : (
            ""
          )}
          {match.data.title !="" ? (
            <div className="heading-padding-left">
              <h1 className="sidebarPagesHeading">{match.data.title}</h1>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Navigationtitle;
